var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.683a.65.65 0 0 1 .65.65v7.764l3.557-3.557a.65.65 0 0 1 .92.92L8.46 13.126a.65.65 0 0 1-.92 0L2.874 8.46a.65.65 0 0 1 .919-.92l3.557 3.557V3.333a.65.65 0 0 1 .65-.65Z",
    fill: "currentColor"
  })));
};

export { Svg16 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03Ljk5OTk4IDIuNjgzMzNDOC4zNTg5NyAyLjY4MzMzIDguNjQ5OTggMi45NzQzNSA4LjY0OTk4IDMuMzMzMzNMOC42NDk5OCAxMS4wOTc0TDEyLjIwNyA3LjU0MDM4QzEyLjQ2MDkgNy4yODY1NCAxMi44NzI0IDcuMjg2NTQgMTMuMTI2MyA3LjU0MDM4QzEzLjM4MDEgNy43OTQyMiAxMy4zODAxIDguMjA1NzggMTMuMTI2MyA4LjQ1OTYyTDguNDU5NiAxMy4xMjYzQzguMjA1NzYgMTMuMzgwMSA3Ljc5NDIgMTMuMzgwMSA3LjU0MDM2IDEzLjEyNjNMMi44NzM3IDguNDU5NjJDMi42MTk4NiA4LjIwNTc4IDIuNjE5ODYgNy43OTQyMiAyLjg3MzcgNy41NDAzOEMzLjEyNzU0IDcuMjg2NTQgMy41MzkwOSA3LjI4NjU0IDMuNzkyOTQgNy41NDAzOEw3LjM0OTk4IDExLjA5NzRMNy4zNDk5OCAzLjMzMzMzQzcuMzQ5OTggMi45NzQzNSA3LjY0MSAyLjY4MzMzIDcuOTk5OTggMi42ODMzM1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";